module.exports = __webpack_public_path__ + "static/media/sony-alpha-1.47d211a6.jpg";